import { trackElementClicked } from '@/features/shared/analytics/element'
import { PDP_ADD_TO_CART } from '@/features/shop/components/ProductDetail/constants'
import { type UniversalProductLocation } from '@/features/shop/services/UniversalProduct/types'
import { getProductPageUrl } from '@/features/shared/utils/getProductPageUrl'
import { getRetailerUrl } from '@shared/constants/routes'

export const getRouteForAfterAddToCart = (
  selectedLocation: UniversalProductLocation | undefined,
  universalProducts: {
    storeId?: number
    id: number
    universal_id: string | undefined
    name: string
  }[],
  store_id: number,
  store_location_id: number,
) => {
  if (
    selectedLocation?.store_id !== store_id ||
    selectedLocation.store_location_id !== store_location_id
  ) {
    return ''
  }
  const availableProduct = universalProducts.find((up) => up.storeId === selectedLocation.store_id)
  const route = availableProduct
    ? `${getProductPageUrl(availableProduct)}?${PDP_ADD_TO_CART}=true`
    : getRetailerUrl(selectedLocation.store_name)

  trackElementClicked({
    content: 'ungated add to cart',
    type: 'button',
    next_location: route,
  })
  return route
}
